import * as React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import ModalChapter from "../../Base/Chapters/ModalChapter";
import renderChapter from "./renderChapter";
import chapterDefs from "./chapterDefs";
import {
  create,
  destroyPatchForm,
  destroyPostForm,
  constants,
  update,
  detailUrl,
  useChecklistForm,
} from "../../../../store/checklists";
import { setActiveFormInstance } from "../../../../store/base";

export default function ChecklistForm({
  method,
  id,
  onCheckout,
  isOpen,
  instance,
}) {
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();
  const storeName = constants.STORE_NAME;

  const { push } = useHistory();
  const formLoaded = Boolean(useChecklistForm(method, id));

  React.useEffect(() => {
    if (isOpen && instance) {
      dispatch(
        setActiveFormInstance({
          storeName,
          data: instance,
        })
      );
    }
  }, [instance, isOpen]);

  const checkout = (success) => {
    if (method === "POST") {
      dispatch(destroyPostForm(success));
    } else if (method === "PATCH") {
      dispatch(destroyPatchForm(success));
    }

    onCheckout();
  };

  const onSuccess = (_, returned) => {
    setLoading(false);
    checkout(true);

    if (method === "POST") {
      push(detailUrl({ id: returned.id }));
    }
  };

  const onSubmit = () => {
    setLoading(true);
    if (method === "POST") {
      dispatch(
        create({
          successCallback: onSuccess,
          errorCallback: () => setLoading(false),
        })
      );
    } else if (method === "PATCH") {
      dispatch(
        update({
          id,
          successCallback: onSuccess,
          errorCallback: () => setLoading(false),
        })
      );
    }
  };

  const onDone = () => {
    checkout(false);
  };

  return (
    <ModalChapter
      storeName={constants.STORE_NAME}
      chapterDefs={chapterDefs}
      onRenderChapter={(key) => renderChapter({ key, method, storeName })}
      submitCallback={onSubmit}
      title={method === "POST" ? "Skapa checklista" : "Uppdatera checklista"}
      onDone={onDone}
      loading={!formLoaded || loading}
      isOpen={isOpen}
    />
  );
}
